<template lang="pug">
.mbn-banner(v-if="!$route.meta.removeBanners" ref="banner")
  .main-container-wide
    rogue-link.main-logo(to="/deals" data-track="mbn-banner-logo-white-logo")
      img(alt="Matte Black November" src="https://assets.roguefitness.com/image/upload/v1636134902/UI/matte_black/matte-black-november-WHITE_iphu6j.svg" :width="279" :height="57")
    .deals
      rogue-link.hot-deals(to="/deals?deal_type=rogue_promo_enabled" data-track="mbn-banner-logo-hotdeals")
        img(alt="Hot Deals | On Popular Gear" src="https://assets.roguefitness.com/image/upload/v1636136384/UI/matte_black/hotdeals-onpopulargear_ix5jiz.svg" :width="120" :height="46")
      .plus +
      rogue-link.mbf-exclusives(v-if="showMBFExclusive" to="/deals?deal_type=rogue_promo_enabled" data-track="mbn-banner-logo-mbf-exclusives")
        img(alt="MBF Exclusives | On Popular Gear" src="https://assets.roguefitness.com/image/upload/v1666358758/UI/logos/mbf-exclusives_mohmmy.svg" :width="170" :height="46")
      .plus(v-if="showMBFExclusive") +
      rogue-link.hundo(to="/deals?deal_type=rogue_hundo_enabled" data-track="mbn-banner-logo-hundo-pricing")
        img(alt="Hundo Pricing | Buy More Save More" src="https://assets.roguefitness.com/image/upload/v1636136384/UI/matte_black/hundopricing-buymoresavemore_ryghu8.svg" :width="170" :height="46")
      .plus(v-if="showFiveForFive") +
      rogue-link.five-for-five(v-if="showFiveForFive" to="/deals?deal_type=5for5" data-track="mbn-banner-logo-five-for-five-logo")
        img(:alt="`5 items for ${$rogue.currency(5, { hideFractionalUnits: true })} shipping`" :src="fiveForFiveWhiteImgSrc" :width="100" :height="40" )
  deals-newsletter-form(v-if="showForm" :show-cancel="false" data-track="mbn-sign-up")
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, useTemplateRef } from 'vue'
import DealsNewsletterForm from '@/js/pages/deals/deals-newsletter-form.vue'
import { useRogue } from '@/js/services/Rogue'

withDefaults(defineProps<{
  showForm?: boolean,
}>(), {
  showForm: true,
})

const rogue = useRogue()
const banner = useTemplateRef<HTMLElement>('banner')

const showFiveForFive = computed<boolean>(() => rogue.featureFlags.isOn('fiveforfive_enabled'))
const showMBFExclusive = computed<boolean>(() => rogue.featureFlags.isOn('mbf_exclusives_enabled'))

const fiveForFiveWhiteImgSrc = computed<string>(() => {
  switch (rogue.site.code) {
    case 'EUR':
      return 'https://assets.roguefitness.com/image/upload/UI/matte_black/5-for-5-EU-White.svg'
    case 'GBR':
      return 'https://assets.roguefitness.com/image/upload/UI/matte_black/5-for-5-Pound-White.svg'
    default:
      return 'https://assets.roguefitness.com/image/upload/UI/matte_black/5-for-5-US-White.svg'
  }
})

onMounted(() => {
  if (document && rogue.appContext) {
    nextTick(() => {
      if (banner.value) {
        document.documentElement.style.setProperty('--mbn-banner-height', `${banner.value.scrollHeight}px`)
      }
    })
  }
})
</script>
<style lang="scss" scoped>
.mbn-banner {
  background: $color-black;
  padding: $space-xs 0;

  .main-container-wide {
    color: $color-white;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    padding-top: $space-xxs;

    img {
      display: block;
      max-width: 100%;
    }

    .deals {
      display: none;

      @media (min-width: $tablet) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-family: $font-base;
        font-size: $size-xl;
        border-left: 2px solid $color-white;
        margin-left: $space-s;
        padding-left: $space-s;
      }

      .plus {
        width: 30px;
        text-align: center;
      }
    }
  }
}
</style>
